import PermissionsPage from '../../../components/admin/permissions/PermissionsPage'

export default function Permissions() {
  return <PermissionsPage />
}
